import styles from "./PullToRefreshIndicator.module.css";

interface PullToRefreshIndicatorProps {
	pullDistance: number;
	isRefreshing: boolean;
	isThresholdReached: boolean;
}

export function PullToRefreshIndicator({
	pullDistance,
	isRefreshing,
	isThresholdReached,
}: PullToRefreshIndicatorProps) {
	// Don't show anything if not pulling or refreshing
	if (pullDistance === 0 && !isRefreshing) return null;

	const rotation = Math.min((pullDistance / 80) * 360, 360);
	const opacity = Math.min(pullDistance / 80, 1);

	return (
		<div
			className={styles.container}
			style={{
				transform: `translateY(${Math.min(pullDistance, 100)}px)`,
				opacity,
			}}
		>
			<div className={styles.content}>
				{isRefreshing ? (
					<div className={styles.spinner} />
				) : (
					<svg
						className={styles.arrow}
						style={{
							transform: `rotate(${rotation}deg)`,
							fill: isThresholdReached ? "#3265f0" : "#666",
						}}
						width="24"
						height="24"
						viewBox="0 0 24 24"
						role="img"
						aria-label="Pull to refresh"
					>
						<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
					</svg>
				)}
			</div>
		</div>
	);
}
